import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cx from 'classnames';
import { colorButton, colorButtonColorPrefix, colorButtonSelected } from './classNames';
import { jsx as _jsx } from "react/jsx-runtime";
export var renderColorButton = function renderColorButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      value = _ref.value,
      isSelected = _ref.isSelected;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: cx(colorButton, "".concat(colorButtonColorPrefix).concat(value), _defineProperty({}, colorButtonSelected, isSelected)),
    onClick: onClick,
    children: label
  });
};